import React, { Component } from 'react';
import Wrapper from '../common/Wrapper';
import RoomsAndStudents from '../RoomsAndStudents';
import { MenuItem} from 'react-bootstrap'
import history from '../../history';
import PropTypes from 'prop-types'
import { routesUrls } from '../../settings/routes';

class CustomItems extends Component {
  static contextTypes = {formatMessage: PropTypes.any}
  render() {
    const {formatMessage} = this.context;
    return <React.Fragment>
      <MenuItem
        onClick={() => {
          history.push(routesUrls.dashboard)
        }}
      >{formatMessage('navTitleDashboard')}</MenuItem>
      <MenuItem
        active
        onClick={() => {
          history.push(routesUrls.rooms_students)
        }}
      >{formatMessage('navTitleClassRooms')}</MenuItem>
      <MenuItem
        
        onClick={() => {
          history.push(routesUrls.students)
        }}
      >{formatMessage('navTitleStudents')}</MenuItem>
   </React.Fragment>
  }
}

const RoomsAndStudentsPage = () => {
  return <Wrapper 
    renderButtonNav = {false}
    CustomItems={CustomItems}
  >
    <RoomsAndStudents />
  </Wrapper>
}

export default RoomsAndStudentsPage;



// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/routes/RoomsAndStudentsPage.js